module.exports = __webpack_public_path__ + "img/biotexcom.c6766530.png";